"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { usePlasmicCanvasContext } from "@plasmicapp/host";
import { useEffect, useState } from "react";
export function BackToTop({ children, className }) {
    const inEditor = usePlasmicCanvasContext();
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const update = () => {
            // Show the button once the page is scrolled at least half a screen down.
            setVisible(window.scrollY >= window.innerHeight / 2);
        };
        update();
        window.addEventListener("scroll", update, { passive: true });
        return () => {
            window.removeEventListener("scroll", update);
        };
    }, []);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const shown = inEditor || visible;
    return (_jsx("button", { type: "button", className: className, onClick: scrollToTop, "aria-label": "Back to top", "aria-hidden": !shown, tabIndex: shown ? undefined : -1, style: {
            opacity: shown ? 1 : 0,
            visibility: shown ? "visible" : "hidden",
            pointerEvents: shown ? "auto" : "none",
            transition: "opacity 300ms ease, visibility 300ms ease",
        }, children: children }));
}
